export default __webpack_public_path__ + "static/media/clock.f36cb133.svg";